import { render } from "./AttentionIcon.vue?vue&type=template&id=de72208a&scoped=true"
const script = {}

import "./AttentionIcon.vue?vue&type=style&index=0&id=de72208a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de72208a"]])

export default __exports__